import React, { useState, useEffect } from "react"
import { Button, styled, Box, TextField, Drawer } from "@mui/material"

import StepperSeeDetailsSuscriber from "../RightModals/SeeDetailsSuscriber"
import { getSuscriberRefId } from "../../../app/services/Suscriber/getSuscriberFromRefId"

import { useNavigate, useParams } from "react-router-dom"
import useStyleSearchSubscriber from "./useStyleSearchSubscriber"

import {
  getSubscriberStatus,
  getUsersOfSuscriber,
} from "../../../redux/actions/Suscriber"
import { useDispatch } from "react-redux"
import { getSubscriberSuscriptionProduct } from "../../../redux/actions/Customers_and_products"

const InputContainer = styled(Box)(() => ({
  width: "30rem",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignContent: "center",
  gap: "1.5rem",
  // top
  padding: "5% 0% 0% 7%",
  "@media all and (max-width: 700px)": {
    width: "80%",
  },
}))

const BoxInput = styled(Box)(() => ({
  width: "30rem",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignContent: "center",
  gap: "1.5rem",
  color: "#4B4952",
  fontSize: 18,
  fontFamily: "roboto",
  "@media all and (max-width: 700px)": {
    width: "100%",
  },
}))

const BoxRoot = styled(Box)(() => ({
  width: "100%",
  overflow: "hidden",
}))

const InputButton = styled(Button)(() => ({
  background: "#1C846F",
  "&:hover": {
    background: "#0CABA8",
  },
  borderRadius: "5rem",
  color: "#fff",
}))

export const SearchSubscriber = ({ setLoading }) => {
  const { id } = useParams()

  const navigate = useNavigate()

  const [clicod, setclicod] = useState("")
  const [suscriber, setsuscriber] = useState(null)
  const [statesSuscriber, setstatesSuscriber] = useState([])
  const [error, seterror] = useState(false)
  const [stateSubscriberStep, setstateSubscriberStep] = useState(false)

  const [countProducts, setCountProducts] = useState(null)
  const [countUser, setCountUser] = useState(null)
  const dispatch = useDispatch()

  const classes = useStyleSearchSubscriber()

  const handleChangeClicod = (event) => {
    seterror(false)
    setclicod(event.target.value)
  }

  const searchSuscriber = () => {
    if (id === clicod && !error) {
      handleGetSuscriber(clicod)
    } else {
      navigate(`/subscribers/${clicod}`)
    }
  }

  const handleSearchSubmit = (event) => {
    if (event.type === "keydown" && event.key === "Enter" && clicod !== "") {
      searchSuscriber()
    }
  }

  // request get and set status list or error message
  const handleGetNameStatusCode = async () => {
    const status = await dispatch(getSubscriberStatus())
    setstatesSuscriber(status)
  }

  // request get suscriber and set in state or error message
  const handleGetSuscriber = async (id) => {
    setLoading(true)
    try {
      const params = {
        clicod: id,
      }
      const getsuscriber = await getSuscriberRefId(params)
      setsuscriber(getsuscriber.data)
      await handleGetNameStatusCode()
      await getSuscriptions(getsuscriber.data?.subscriber_id)
      await getUsersOfSuscriberLength(getsuscriber.data?.subscriber_ref_id)
      setstateSubscriberStep(true)
    } catch (err) {
      seterror(true)
    }
    setLoading(false)
  }

  // setcountproducts - get length subscriptions and products
  const getSuscriptions = async (subscriberid) => {
    const response = await dispatch(
      getSubscriberSuscriptionProduct(subscriberid),
    )
    setCountProducts(response.length)
  }

  // setCountUser - get length users of subscriber
  const getUsersOfSuscriberLength = async (clicod) => {
    const response = await dispatch(getUsersOfSuscriber(clicod))
    setCountUser(response.length)
  }

  useEffect(async () => {
    if (id) {
      setclicod(id)
      await handleGetSuscriber(id)
    }
  }, [id])

  const listDetailsSubscriber = (anchor) => (
    <Box className={classes.stepperStyleSeeMore} role="presentation">
      <StepperSeeDetailsSuscriber
        setsuscriber={setsuscriber}
        suscriber={suscriber}
        statesSuscriber={statesSuscriber}
        setstateSubscriberStep={setstateSubscriberStep}
        setLoading={setLoading}
        countProducts={countProducts}
        countUser={countUser}
      />
    </Box>
  )

  return (
    <BoxRoot>
      <InputContainer>
        <BoxInput>
          <div className={classes.title}>
            Ingrese el número de suscriptor que desea buscar:
          </div>
        </BoxInput>
        <TextField
          value={clicod}
          onChange={handleChangeClicod}
          onKeyDown={handleSearchSubmit}
          placeholder={"Ej: 90844"}
          error={error}
          helperText={error ? "El suscriptor ingresado no existe" : ""}
        />
        <InputButton onClick={searchSuscriber}>Buscar</InputButton>
      </InputContainer>
      <Drawer anchor={"right"} open={stateSubscriberStep}>
        {listDetailsSubscriber("right")}
      </Drawer>
    </BoxRoot>
  )
}
